var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    "data-name": "Group 1193",
    transform: "translate(-1187 -293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    transform: "translate(1187 293)",
    fill: "#fff",
    stroke: "#e4e7eb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M8.729,10.211H14.8a.8.8,0,0,1,0,1.6H8.729l1.84,1.84a.8.8,0,1,1-1.05,1.207.741.741,0,0,1-.086-.087l-3.2-3.2a.8.8,0,0,1,0-1.12l3.2-3.2a.8.8,0,0,1,1.136,1.12l-1.848,1.84Z",
    transform: "translate(1207.055 290.996) rotate(90)",
    fill: "#27ab83"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpStock);
export default __webpack_public_path__ + "static/media/arrow-up-stock.a3fa4b1f5c983e8ca922e3177e35c53a.svg";
export { ForwardRef as ReactComponent };